(function() {
  exports.en = {
    operators: {
      title: 'Operator|Operators'
    },
    previous_crop: {
      corn: 'Corn (grain)'
    },
    field_define: {
      skip_clu: 'Skip CLUs'
    }
  };

  exports.en_ZA = {
    operators: {
      title: 'Farmer|Farmers'
    },
    previous_crop: {
      corn: 'Maize'
    },
    field_define: {
      skip_clu: 'Skip field boundaries'
    }
  };

}).call(this);
